import { useState } from 'react';
import { useSpring } from 'react-spring';
const TRANSLATION = 150;

export function useAnimationValues() {
    const [finished, setFinished] = useState(false);

    const animation = useSpring({
        to: async (next: any) => {
            await next({
                topToTopLabel: 'translateY(0px)',
                topToBottomLabel: 'translateY(0px)',
                bottomToTopLabel: 'translateY(-0px)',
                bottomTobottomLabel: 'translateY(-0px)',
                plusLabel: 'translateY(0)',
                minusLabel: 'translateY(-0)',
            });
            await next({
                topToTopLabel: `translateY(${-TRANSLATION}vh)`,
                topToBottomLabel: `translateY(${TRANSLATION}vh)`,
                bottomToTopLabel: `translateY(${-TRANSLATION}vh)`,
                bottomTobottomLabel: `translateY(${TRANSLATION}vh)`,
                
                labelOpacity: 0,
                height: 'auto',
                transform: 'translateX(0)',
                titleTranslate: 'translateX(0)',
                config: { duration: 700 }
            });
            
        },
        from: {
            topToTopLabel: `translateY(${-TRANSLATION}vh)`,
            topToBottomLabel: `translateY(${-TRANSLATION}vh)`,
            bottomToTopLabel: `translateY(${TRANSLATION}vh)`,
            bottomTobottomLabel: `translateY(${TRANSLATION}vh)`,
            labelOpacity: 1,
            plusLabel: `translateY(${-TRANSLATION}vh)`,
            minusLabel: `translateY(${TRANSLATION}vh)`,
            transform: 'translateX(100vw)',
            height: 0,
            titleTranslate: 'translateY(100px)'
        },
        onRest: () => setFinished(true)
    }) as any;
    

    return [animation, finished];
}
